module.exports = __webpack_public_path__ + "img/oufu_75x93x8.prt.c4375925.jpg";